/**
 * Thermal's Thermal Pending (user, 2026-10-29): what Processing issued to it, what it is working,
 * and what it sent back. Open by whoever receives or fills the slip.
 */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { HandoffListPage } from "@/features/processing/components/handoff-list-page";

const search = z.object({
  tab: z.string().default("pending"),
  from: z.string().optional(),
  to: z.string().optional(),
  page: z.number().int().min(1).default(1),
});

export const Route = createFileRoute("/_app/thermal/pending/")({
  validateSearch: search,
  beforeLoad: () => {
    const { can } = useAuth.getState();
    if (!can("processing.thermal.receive") && !can("processing.thermal.slip"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return (
    <HandoffListPage
      form="thermal"
      audience="section"
      facilityId={selected?.id}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
